import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { faLinkSimple } from '@fortawesome/pro-solid-svg-icons';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'shared/button';
import { post } from 'helpers/api';

export default function ResyncButton({ baseParams, partnerId, resyncUrl, showResyncButton, onResync }) {
  const [resyncing, setResyncing] = useState(false);

  if (!showResyncButton) return null;

  const resyncTooltip = (
    <Tooltip id={`Resync-tooltip-${partnerId}`}>
      Resync account reps to company settings
    </Tooltip>
  );

  function handleResyncClick() {
    setResyncing(true);
    post(resyncUrl, baseParams).then((res) => {
      onResync(res);
    }).finally(() => {
      setResyncing(false);
    });
  }

  return (
    <OverlayTrigger overlay={resyncTooltip} placement="bottom">
      <Button.Secondary disabled={resyncing} icon={faLinkSimple} plain onClick={handleResyncClick}>
        {resyncing ? 'Resyncing...' : 'Resync'}
      </Button.Secondary>
    </OverlayTrigger>
  );
}

ResyncButton.propTypes = {
  baseParams: PropTypes.object.isRequired,
  partnerId: PropTypes.number.isRequired,
  resyncUrl: PropTypes.string.isRequired,
  showResyncButton: PropTypes.bool.isRequired,
  onResync: PropTypes.func.isRequired,
};
